import { useEffect } from 'react'
import { appStore, isApplicationLocked } from '@/store/app'

/**
 * Shows a browser confirmation dialog when the user tries to close/reload
 * the tab while there are unsaved changes (dirty state in appStore).
 */
export function useUnsavedChangesWarning() {
	useEffect(() => {
		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			const { dirty, user } = appStore.snapshot()

			// Only warn if there are unsaved changes and application is not locked
			if (dirty && !isApplicationLocked(user?.application_process)) {
				// Standard way to trigger the browser's confirmation dialog
				e.preventDefault()
				// For older browsers, return a string (the message is ignored by modern browsers)
				e.returnValue = ''
				return ''
			}
		}

		window.addEventListener('beforeunload', handleBeforeUnload)
		return () => window.removeEventListener('beforeunload', handleBeforeUnload)
	}, [])
}
